import type { VoidFunctionComponent } from 'react';

import { prettyMDY } from '../../../../../shared/utils/dates';
import type { SnippetRejectionDetails } from '../../../../../shared/snippets';

import styles from './RejectedBanner.module.less';

export type RejectionTarget = 'snippet' | 'match';

type Props = {
  rejectionDetails: SnippetRejectionDetails;
  rejectionTarget: RejectionTarget;
};

/**
 * The RejectedBanner component displays a message indicating that a snippet
 * has been rejected. It includes when and by whom it was rejected.
 */
const RejectedBanner: VoidFunctionComponent<Props> = ({ rejectionDetails, rejectionTarget }) => {
  const target = rejectionTarget === 'snippet' ? 'Snippet' : 'Match';
  const rejectedBy = rejectionDetails.rejectedBy;
  const message = rejectionDetails.rejectedBy
    ? `${target} rejected by ${rejectedBy} on ${prettyMDY(rejectionDetails.rejectedAt)}.`
    : `${target} rejected on ${prettyMDY(rejectionDetails.rejectedAt)}.`;
  return (
    <div className={styles.rejectedBanner}>
      {message}
    </div>
  );
};

export default RejectedBanner;
